// extracted by mini-css-extract-plugin
module.exports = {"jobCardExperience":"JobExperience-module_jobCardExperience_0ab31","experienceIcon":"JobExperience-module_experienceIcon_0b854"};